import { FunctionComponent } from "react";
import { Icon } from "../Icon";

type Props = {
  name: string;
};

const MostWantedCard: FunctionComponent<Props> = ({ name }) => {
  const url = "/search/" + name;
  return (
    <a href={url} className="card_container">
      <p className="product_name">{name}</p>
      <Icon iconName="go-to-arrow" className="go-to-arrow" />
    </a>
  );
};

export default MostWantedCard;
